// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const oppet = 'oppen';
  const stangt = 'stangd';
  const stangningsTid = 160;

  document.querySelectorAll('[data-component="filter"]').forEach((rot) => {
    const filterPanel = rot.querySelector('[data-panel-typ="filter"]');
    const sortPanel = rot.querySelector('[data-panel-typ="sortering"]');
    const rutnat = rot.querySelector('[data-rutnat]');
    const pillar = rot.querySelector('[data-pillar]');

    const kort = () => Array.from(rutnat ? rutnat.querySelectorAll('.kort') : []);

    let aktivFilter = { storlek: null, farg: null, kategori: null };
    let aktivSortering = 'manual';
    let aktivPanel = null;
    let stangTimer = null;

    const hamtaKnapp = (typ) => rot.querySelector(`[data-action~="filter/oppna"][data-filter-typ="${typ}"]`);

    const stangAllt = () => {
      window.clearTimeout(stangTimer);
      [filterPanel, sortPanel].forEach((p) => {
        if (!p) return;
        p.dataset.state = stangt;
      });
      rot.querySelectorAll('[data-action~="filter/oppna"]').forEach((k) => {
        k.setAttribute('aria-expanded', 'false');
      });
      stangTimer = window.setTimeout(() => {
        [filterPanel, sortPanel].forEach((p) => { if (p) p.hidden = true; });
        aktivPanel = null;
      }, stangningsTid);
    };

    const oppnaPanel = (typ) => {
      window.clearTimeout(stangTimer);
      const panel = typ === 'sortering' ? sortPanel : filterPanel;
      if (!panel) return;

      [filterPanel, sortPanel].forEach((p) => {
        if (!p || p === panel) return;
        p.dataset.state = stangt;
        p.hidden = true;
      });

      panel.hidden = false;
      panel.dataset.state = oppet;
      rot.dataset.state = oppet;
      aktivPanel = typ;

      rot.querySelectorAll('[data-action~="filter/oppna"]').forEach((k) => {
        k.setAttribute('aria-expanded', String(k.dataset.filterTyp === typ));
      });
    };

    const vaxla = (typ) => {
      if (aktivPanel === typ && (typ === 'sortering' ? sortPanel : filterPanel)?.dataset.state === oppet) {
        stangAllt();
      } else {
        oppnaPanel(typ);
      }
    };

    const uppdateraPillar = () => {
      if (!pillar) return;
      pillar.innerHTML = '';
      Object.entries(aktivFilter).forEach(([typ, varde]) => {
        if (!varde) return;
        const pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'rutnat-filterrad__pill';
        pill.dataset.action = 'filter/ta-bort-pill';
        pill.dataset.filterTyp = typ;
        pill.dataset.filterVarde = varde;
        pill.setAttribute('aria-label', `Remove filter: ${varde}`);
        pill.textContent = `${varde} ×`;
        pillar.appendChild(pill);
      });
    };

    const tillampFilter = () => {
      const korten = kort();
      korten.forEach((k) => {
        const storlekar = k.dataset.storlek || '';
        const farger = k.dataset.farg || '';
        const kategorier = k.dataset.kategori || '';
        const ok =
          (!aktivFilter.storlek || storlekar.includes(aktivFilter.storlek)) &&
          (!aktivFilter.farg || farger.includes(aktivFilter.farg)) &&
          (!aktivFilter.kategori || kategorier.includes(aktivFilter.kategori));
        k.hidden = !ok;
      });

      if (aktivSortering !== 'manual' && rutnat) {
        const synliga = korten.filter((k) => !k.hidden);
        const dolda = korten.filter((k) => k.hidden);
        synliga.sort((a, b) => {
          const pa = parseInt(a.dataset.pris || '0', 10);
          const pb = parseInt(b.dataset.pris || '0', 10);
          const ta = (a.querySelector('.kort__rad--vanster')?.textContent || '').trim().toLowerCase();
          const tb = (b.querySelector('.kort__rad--vanster')?.textContent || '').trim().toLowerCase();
          const da = parseInt(a.dataset.datum || '0', 10);
          const db = parseInt(b.dataset.datum || '0', 10);
          if (aktivSortering === 'price-asc') return pa - pb;
          if (aktivSortering === 'price-desc') return pb - pa;
          if (aktivSortering === 'title-asc') return ta < tb ? -1 : ta > tb ? 1 : 0;
          if (aktivSortering === 'title-desc') return tb < ta ? -1 : tb > ta ? 1 : 0;
          if (aktivSortering === 'created-desc') return db - da;
          return 0;
        });
        [...synliga, ...dolda].forEach((k) => rutnat.appendChild(k));
      }

      uppdateraPillar();
    };

    const sattFilterVal = (typ, varde, knapp) => {
      const erAktiv = aktivFilter[typ] === varde;
      aktivFilter[typ] = erAktiv ? null : varde;
      if (knapp) knapp.setAttribute('aria-pressed', String(!erAktiv));
      rot.querySelectorAll(`[data-filter-typ="${typ}"][data-action~="filter/vald"]`).forEach((b) => {
        if (b !== knapp) b.setAttribute('aria-pressed', 'false');
      });
      tillampFilter();
    };

    rot.addEventListener('click', (e) => {
      const oppnaKnapp = e.target.closest('[data-action~="filter/oppna"]');
      if (oppnaKnapp && rot.contains(oppnaKnapp)) {
        vaxla(oppnaKnapp.dataset.filterTyp);
        return;
      }

      const valdKnapp = e.target.closest('[data-action~="filter/vald"]');
      if (valdKnapp && rot.contains(valdKnapp)) {
        const typ = valdKnapp.dataset.filterTyp;
        const varde = valdKnapp.dataset.filterVarde;
        if (typ === 'sortering') {
          rot.querySelectorAll('[data-filter-typ="sortering"][data-action~="filter/vald"]').forEach((b) => {
            b.setAttribute('aria-pressed', String(b === valdKnapp));
          });
          aktivSortering = varde;
          tillampFilter();
          stangAllt();
        } else {
          sattFilterVal(typ, varde, valdKnapp);
        }
        return;
      }

      const pillKnapp = e.target.closest('[data-action~="filter/ta-bort-pill"]');
      if (pillKnapp && rot.contains(pillKnapp)) {
        const typ = pillKnapp.dataset.filterTyp;
        const varde = pillKnapp.dataset.filterVarde;
        aktivFilter[typ] = null;
        const panelKnapp = rot.querySelector(`[data-filter-typ="${typ}"][data-filter-varde="${varde}"][data-action~="filter/vald"]`);
        if (panelKnapp) panelKnapp.setAttribute('aria-pressed', 'false');
        tillampFilter();
        return;
      }
    });

    document.addEventListener('click', (e) => {
      if (aktivPanel && !rot.contains(e.target)) {
        stangAllt();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const aktiv = rot.querySelector('[data-action~="filter/oppna"][aria-expanded="true"]');
      if (aktiv) { stangAllt(); aktiv.focus(); }
    });
  });
})();

